import { TrackFcn, TrackingData } from '@common/react/tracking';
import { useCallback } from 'react';

export const getAnalytics = () => undefined;

export const useTracking = () => {
    const track: TrackFcn = useCallback(async () => {}, []);
    const page = useCallback(async () => {}, []);
    const getAnonymousId = useCallback(async () => undefined, []);
    const identify = useCallback(async () => {}, []);

    return { track, page, getAnonymousId, identify };
};

/* eslint-disable @typescript-eslint/no-unused-vars */
export const useTrackModalShown = (
    modalName: string,
    data?: TrackingData
) => {};

export const useTrackPageViewed = (view: string, data?: TrackingData) => {};
/* eslint-enable @typescript-eslint/no-unused-vars */
